import React from 'react'
import { 
    Button, 
    Table, 
    Row, 
    Popconfirm, 
    Modal, 
    Input, 
    message
} from 'antd'
import { firAuth, firestore } from '../../../service/firebase'
import './User.scss'


export default class User extends React.Component {
    
    columns = [
        // { title: "", dataIndex: 'logo', key: 'logo', render: logo => {
        //     if(logo.length > 0) {
        //         return (
        //             <img style={{maxWidth: 50, maxHeight: 50}} src={logo} alt="LOGO" />
        //         )
        //     } else {
        //         return (
        //             <img style={{maxWidth: 50, maxHeight: 50}} src={require('../../../assets/ic_user_placeholder.png')} alt="LOGO" />
        //         )
        //     }
        // } },
        { title: "Name", dataIndex: 'name', key: 'name' },
        { title: "Email", dataIndex: 'email', key: 'email' },
        { title: 'Actions', dataIndex: '', key: 'action', render: (item) => {
            return (
                <span>
                    <Popconfirm title="Are you sure delete?" onConfirm={() => this.handleDelete(item)} okText="Yes" cancelText="No">
                        <a>Delete</a>
                    </Popconfirm>
                </span>
            )
        }}
    ]

    dataList = []

    state = {
        showModal: false,
    }

    /*--------------------------------------------------------------*/
    /* Constructor */
    /*--------------------------------------------------------------*/

    constructor(props) {
        super(props)
        this.loadEvents()
    }


    /*--------------------------------------------------------------*/
    /* Load data */
    /*--------------------------------------------------------------*/

    loadEvents() {

        firestore.collection('User')
        .onSnapshot(snapshot => {
    
            snapshot.docChanges().forEach(change => {
    
                let data = change.doc.data()
    
                if(change.type === 'added') {

                    if(data['type'] === 'login') return
                    this.dataList.push(data)

                } else if(change.type === 'modified') {

                    this.dataList = this.dataList.map(item => {
                        if(item.id === data.id) {
                            return data
                        } else {
                            return item
                        }
                    })

                } else {

                    for(let i = 0; i < this.dataList.length; i++) {
                        let item = this.dataList[i]
                        if(item.id === data.id) {
                            this.dataList.splice(i, 1)
                            break
                        }
                    }

                }
            })
    
            this.forceUpdate()
        })
    
    }


    /*--------------------------------------------------------------*/
    /* Handle Event */
    /*--------------------------------------------------------------*/

    handleDelete(item) {
        firestore.collection('User').doc(item.id).delete();
    }

    handleAddUser() {
        this.setState({showModal: true})
    }

    handleChange(key, value) {
        let state = this.state
        state[key] = value
        this.setState(state)
    }

    handleClose() {
        this.setState({showModal: false})
    }

    handleOK() {
        let { email, password } = this.state
        console.log(email, password)

        if(!email || !password) {
            message.error('Email or password should not empty!')
            return
        }

        firAuth.createUserWithEmailAndPassword(email, password)
        .then(result => {
            console.log("Result", result)
            message.info('User created!')
        })
        .catch(error => {
            console.log("Error", error)
            message.error(error.toString())
        })

        this.setState({showModal: false})
    }


    /*--------------------------------------------------------------*/
    /* Render Functions */
    /*--------------------------------------------------------------*/
   
    render() {

        return (
            <div className="user">

                <Row style={{textAlign: 'right', padding: 10}}>
                    <Button type="primary" icon="plus" onClick={() => this.handleAddUser()}>User</Button>
                </Row>

                <Table 
                    style={{margin: 10, background: 'white'}}
                    columns={this.columns}
                    rowKey={record => record.id}
                    dataSource={this.dataList} />

                
                <Modal
                    title='Add New User'
                    visible={this.state.showModal}
                    onOk={() => this.handleOK()}
                    onCancel={() => this.handleClose()}>

                    <Row className="input-row">
                        <div className="input-label">Name</div>
                        <Input value={this.state.name} onChange={evt => this.handleChange('name', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Email</div>
                        <Input value={this.state.email} onChange={evt => this.handleChange('email', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Password</div>
                        <Input value={this.state.password} type="password" onChange={evt => this.handleChange('password', evt.target.value)} />
                    </Row>

                </Modal>

            </div>
        )
    }
}
